// Export all services
var cookie_1 = require('./services/cookie');
exports.Cookie = cookie_1.Cookie;
//# sourceMappingURL=services.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/ng2-cookies/src/services.js
 ** module id = 37
 ** module chunks = 9
 **/